export default __webpack_public_path__ + "static/media/otp.a294b038.jfif";